import { applyMiddleware, compose, createStore } from "redux";
import thunk from "redux-thunk";
import { routerMiddleware } from "connected-react-router";
import { loadingBarMiddleware } from "react-redux-loading-bar";
import rootReducer from "../reducers";
import http from "../common/HttpService";


export default function configureStore(history, initialState) {

    const middleware = [
        thunk,
        routerMiddleware(history),
        loadingBarMiddleware({
            promiseTypeSuffixes: ["^REQUEST.*", "^(RECEIVE|SUCCESS|ACCEPT).*", "^(FAILED|INVALID).*"]
        })
    ];

    // In development, use the browser's Redux dev tools extension if installed
    const enhancers = [];
    const isDevelopment = process.env.NODE_ENV === "development";
    if (isDevelopment && typeof window !== "undefined" && window.__REDUX_DEVTOOLS_EXTENSION__) {
        enhancers.push(window.__REDUX_DEVTOOLS_EXTENSION__());
    }

    const store = createStore(
        rootReducer(history),
        initialState,
        compose(applyMiddleware(...middleware), ...enhancers)
    );


    http.getAuthData = () => store.getState().login.auth;
    http.setAuthData = (auth) => store.getState().login.auth = auth;
    return store;
}




// WEBPACK FOOTER //
// ./src/store/configureStore.js